<template>
  <div>
    <CCard class="bg-style2">
      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span class="font-weight-bold h6"> <CIcon v-if="icon" :name="icon" class="mr-2"/> {{ caption }} </span>
        <div class="card-header-actions">
          <span class="mr-2">Total : {{ items.length }}</span>
          <CButton
            size="sm"
            color="light"
            variant="outline"
            class="text-white border-white"
            :disabled="loading || !items.length"
            @click="exportAll"
          >
            <CIcon name="cil-cloud-download" class="mr-1"/>
            Export Excel
          </CButton>
        </div>

      </CCardHeader>
      <CCardBody>
        <CDataTable
            :table-filter="{label:$t('search')}"
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            :items="items"
            :fields="fields"
            :items-per-page="small ? 50 : 20"
            :dark="dark"
            pagination
            :loading="loading"
            sorter
        >
          <template #index="{item,index}">
            <td class="text-center"  @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
          </template>

          <template #isTalent="{ item, index}">
            <td class="text-center" > {{ (item.isTalent == true)?$t('gap.found'):$t('gap.notFound') }}</td>
          </template>

          <template #employmentStatus="{ item }">
            <td class="text-center">{{ item.employmentStatus || '-' }}</td>
          </template>



          <template #action="{item,index}">
            <td style="width: 140px">
              <CRow>
                <CCol class="text-center">
<!--                  <CButton class="mr-1" v-c-tooltip="{content: $t('tooltip.detail') }" size="sm" color="info" shape="pill" variant="outline" @click="toggleDetails(item, index)"  >-->
<!--                    <CIcon name="cil-description"/>-->
<!--                  </CButton>-->
                  <CButton class="mr-1" v-c-tooltip="{content: $t('tooltip.assessment') }"  size="sm" color="dark" shape="pill" variant="outline" @click="onChangeAssessment(item, index)"  >
                    <CIcon name="cil-people"/>
                  </CButton>

                </CCol>
              </CRow>
            </td>
          </template>


        </CDataTable>
      </CCardBody>
    </CCard>
    <SearchProfile :is-show="isDialog" :is-select-account="true" @update="onDismiss" :object="nodeData" @select-account="changeAssessment"/>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import SearchProfile from "@/projects/components/Dialog/SearchProfile.vue";
import Organization from "@/projects/views/E-Performances/Organization/index.vue";
import * as XLSX from "xlsx";

export default {
  name: 'History_IDP',
  components: {Organization, SearchProfile},
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Banks'
    },

    fields: {
      type: Array,
      default() {
        return [
          {key:"index", label: "#",  _style: 'width:50px; text-align: center'},
          {key:"code", label:"Code", _style: 'width:30px; text-align: center'},
          {key:"accounts", label:"Name"},
          {key:"employmentStatus", label:"สถานภาพการทำงาน", _style: 'width:180px; text-align: center'},
          {key:"assessor", label:"Assessor"},
          // {key:"isTalent", label: "Talent", _style: 'width:120px; text-align: center'},
          {key:"state", label:"Status",_style: 'width:150px; text-align: center'},
          {key:"action", label: "#", _style: 'width:40px; text-align: center'}
        ]
      }
    },
    type: {
      type: String,
      default: 'cil-user'
    },
    year: {
      type: Number,
      default: null
    },
    item: {
      type: Array,
      default: undefined
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    loading: Boolean,
  },

  data: function () {
    return {
      isDialog: false,
      collapseDuration: 0,

      nodeData:{
        children:[]
      },

      prepare:{},
      items:[]
    }
  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      this.onLoad();
    },

    onLoad() {

    },

    toggleDetails (item,index) {
      item._toggled = !item._toggled
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})

    },
    onDismiss(){
      this.isDialog = false;
    },

    onChangeAssessment(item,index) {
      this.isDialog = true;
      this.prepare = item;
    },

    changeAssessment(item, index) {
      this.isDialog = false;

      var body = {};
      body._id = this.prepare.id;
      body.assessor = item.value._id;

      this.$store.dispatch("idp/changeAssessor", body)
    },
    resolveLocalizedValue(items) {
      if (!Array.isArray(items) || items.length === 0) {
        return '';
      }

      return (
        (items.find((entry) => entry && entry.key === this.lang) || {}).value ||
        (items[0] || {}).value ||
        ''
      );
    },

    buildPersonName(userinfo) {
      if (!userinfo) {
        return '-';
      }

      return [
        this.resolveLocalizedValue(userinfo.prefix),
        this.resolveLocalizedValue(userinfo.firstName),
        this.resolveLocalizedValue(userinfo.lastName)
      ].filter(Boolean).join(' ') || '-';
    },

    buildItems(histories) {
      this.items = (Array.isArray(histories) ? histories : []).map((history) => ({
        ...history,
        id: history._id,
        code: (((history || {}).accounts || {}).accounts || {}).code || '-',
        accounts: this.buildPersonName(((((history || {}).accounts || {}).accounts || {}).userinfo)),
        employmentStatus: this.resolveLocalizedValue((((((history || {}).accounts || {}).positions || []).at(-1) || {}).status || {}).title) || '-',
        assessor: this.buildPersonName((((((history || {}).assessor || {}).accounts || {}).accounts || {}).userinfo)),
        state: this.resolveLocalizedValue(((((history || {}).status || []).at(-1) || {}).state || {}).title) || '-',
        status: (((history || {}).status || []).at(-1) || {}).state || {},
      }));
    },
    buildExportRows() {
      return this.items.map((entry, index) => ({
        index: index + 1,
        code: entry.code || "-",
        name: entry.accounts || "-",
        employmentStatus: entry.employmentStatus || "-",
        assessor: entry.assessor || "-",
        status: entry.state || "-"
      }));
    },
    exportAll() {
      const workbook = XLSX.utils.book_new();
      const summarySheet = XLSX.utils.json_to_sheet(this.buildExportRows());

      XLSX.utils.book_append_sheet(workbook, summarySheet, "MemberStatus");
      XLSX.writeFile(workbook, `idp-member-status-${this.year || "report"}.xlsx`);
    }
  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
      reportMembers: "report/members",
    }),
    sourceItems() {
      return Array.isArray(this.item) ? this.item : this.reportMembers;
    }
  },

  watch: {
    lang() {
      this.buildItems(this.sourceItems);
    },
    sourceItems: {
      immediate: true,
      handler(value) {
        this.buildItems(value);
      }
    }
  }
}
</script>
<style>

.w50 {
  min-width: 50%;
}

.input-group-append .form-group {
  margin-bottom: 0px;
}

.text-right {
  text-align: end;
}

.bg-login1 {
  border-radius: 1.5rem;
  background: linear-gradient(180deg, #a54af0 0%, #539cf8 60%, #C8CED3 80%);
}
</style>
